import { Box, Typography } from "@mui/material";
import { designTokens } from "../../../theme/designTokens";

const { colors, fonts, fontSizes } = designTokens;

interface SectionHeadingProps {
  label: string;
  title: string;
  highlight?: string;
  subtitle?: string;
}

const SectionHeading = ({ label, title, highlight, subtitle }: SectionHeadingProps) => (
  <Box sx={{ textAlign: "center", mb: { xs: 4, md: 6 } }}>
    <Typography
      variant="overline"
      sx={{
        color: colors.primary,
        fontWeight: fonts.weights.bold,
        letterSpacing: 2,
        display: "block",
        mb: 1,
        fontSize: fontSizes.overline,
      }}
    >
      {label}
    </Typography>
    <Typography
      variant="h3"
      component="h2"
      sx={{
        fontWeight: fonts.weights.bold,
        color: colors.textPrimary,
        fontSize: fontSizes.sectionTitle,
        lineHeight: 1.3,
      }}
    >
      {title}
      {highlight && (
        <Box component="span" sx={{ color: colors.primary }}>
          {" "}
          {highlight}
        </Box>
      )}
    </Typography>
    {subtitle && (
      <Typography
        variant="body1"
        sx={{
          color: colors.textSecondary,
          mt: 2,
          maxWidth: 900,
          mx: "auto",
          lineHeight: 1.7,
        }}
      >
        {subtitle}
      </Typography>
    )}
  </Box>
);

export default SectionHeading;
